import gql from 'graphql-tag';

/**
 * listen for new messages sent to the requested channel
 */
export const SUBSCRIBE_TO_NEW_CHANNEL_MESSAGES = gql`
  subscription($channelId: String!) {
    messagePostedToChannel(channelId: $channelId) {
      id
      senderId
      message
      createdAt
      user {
        id
        name
        avatar
      }
      attachment {
        url
        key
        type
      }
    }
  }
`;
